import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Table = styled.table`
  background: ${(props) => props.theme.background};
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;

  @media (${mobileXXLargeMax}) {
    display: none;
  }

  td {
    border-top: 1px solid ${(props) => props.theme.keyline};
    padding: 10px;
    vertical-align: top;
  }

  tr:first-child {
    td {
      border-top: none;
    }
  }

  button {
    font-size: 16px;
    text-decoration: underline;
    color: ${(props) => props.theme.textDark};
  }
`;

export const MobileTable = styled.div`
  display: none;

  @media (${mobileXXLargeMax}) {
    display: block;
  }
`;

export const MobileBox = styled.div`
  text-align: center;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.keyline};

  h3 {
    font-size: 16px;
  }

  h3,
  p,
  b {
    color: ${(props) => props.theme.textDark};
    margin: 2px 0;
  }

  button {
    font-size: 16px;
    text-decoration: underline;
    color: ${(props) => props.theme.textDark};
  }

  &:last-child {
    border-bottom: none;
  }
`;
